import { Seo } from '../components/Seo';
import { buildTitle, SITE } from '../lib/site';
import { useI18n } from '../i18n';

/** Render a translated string that may contain simple inline <strong>...</strong> tags. */
function RichText({ text }: { text: string }) {
  const parts = text.split(/(<strong>.*?<\/strong>)/g);
  return (
    <>
      {parts.map((part, i) => {
        if (part.startsWith('<strong>')) {
          return <strong key={i}>{part.replace(/<\/?strong>/g, '')}</strong>;
        }
        return <span key={i}>{part}</span>;
      })}
    </>
  );
}

export function PrivacyPage() {
  const { locale: t, fmt, formatDate } = useI18n();
  const p = t.pages.privacy;
  const sub = { SITE: SITE.name, DOMAIN: SITE.domain };

  return (
    <>
      <Seo
        title={buildTitle(p.title)}
        description={p.calloutText.replace(/\{SITE\}/g, SITE.name)}
        path="/privacy"
      />

      <section className="page-header">
        <div className="container">
          <span className="eyebrow">{p.eyebrow}</span>
          <h1>{p.title}</h1>
          <p>{fmt(p.lead, { date: formatDate(new Date()) })}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="prose">
            <div className="callout">
              <div className="title">{p.calloutTitle}</div>
              <p>{fmt(p.calloutText, sub)}</p>
            </div>

            {p.sections.map((s, i) => (
              <div key={i}>
                <h2>{s.h}</h2>
                {s.p.map((para, j) => (
                  <p key={j}><RichText text={fmt(para, sub)} /></p>
                ))}
                {s.ul && (
                  <ul>
                    {s.ul.map((li, j) => (
                      <li key={j}><RichText text={fmt(li, sub)} /></li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
